import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

export type AccountPageBannerContextValue = {
  success: string | null
  error: string | null
  setSuccess: (msg: string | null) => void
  setError: (msg: string | null) => void
  clearBanners: () => void
}

const AccountPageBannerContext = createContext<AccountPageBannerContextValue | null>(null)

export function AccountPageBannerProvider({ children }: { children: ReactNode }) {
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const clearBanners = useCallback(() => {
    setSuccess(null)
    setError(null)
  }, [])

  const value = useMemo(
    () => ({ success, error, setSuccess, setError, clearBanners }),
    [success, error, clearBanners]
  )

  return (
    <AccountPageBannerContext.Provider value={value}>
      {children}
    </AccountPageBannerContext.Provider>
  )
}

export function useAccountPageBanner(): AccountPageBannerContextValue {
  const ctx = useContext(AccountPageBannerContext)
  if (!ctx) {
    throw new Error('useAccountPageBanner must be used within AccountPageBannerProvider')
  }
  return ctx
}
